import { Button, Checkbox, Chip, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, Paper, Table, TableBody, TableCell, TableContainer, TableRow } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import React from 'react';
import Highlighter from "react-highlight-words";
import { connect } from 'react-redux';
import { setLabourQuan, setLabourSelection, setLabourFilterKey } from '../../store/actions';

const useStyles = makeStyles({
  table: {
    width: '100%',
    minHeight: 500,
  },
});

const LabourTable = (props) => {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const [Uyari, setUyari] = React.useState("");
  const selected = props.labours[props.defect] || [];
  let selectedAll = [];
  if (props.selectedDefects) {
    props.selectedDefects.forEach(d => {
      if (props.labours[d])
        selectedAll = [...selectedAll, ...props.labours[d]];
    });
  }
  const handleClick = (event, name, disabled) => {
    if (disabled) {
      return;
    }
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];
    if (selectedIndex === -1) {
      // Add
      newSelected = [...selected, name];
      if (name === '880') {
        setUyari("880-Dezenfeksiyon-Ev/Ticari isletme isciligi icin Metre Kare bilgilerini girmeyi unutmayiniz.");
        setOpen(true);
      }
    } else {
      // Remove
      newSelected = [...selected.slice(0, selectedIndex)
        , ...selected.slice(selectedIndex + 1)
      ]
    }
    props.setLabourFilterKey("");
    props.setLabourSelection(props.defect, newSelected);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const isSelected = (name) => (selected && selected.indexOf(name) !== -1);
  const isUsedBefore = (name) => (selectedAll && selectedAll.indexOf(name) !== -1);

  const highlight = (text) => {
    return <Highlighter
      searchWords={[props.labours?.filterKey]}
      autoEscape={true}
      textToHighlight={text}
    />
  }

  return (
    <>
      <TableContainer className={classes.table} component={Paper}>
        <Table size="small" aria-label="labour table">
          <TableBody>
            {(props.labours?.filtered) && props.labours?.filtered.sort(s => isUsedBefore(s.LabourCode) ? -1 : 1).slice(0, 50).map((row, index) => {
              const labelId = `enhanced-table-checkbox-${index}`;
              const isItemSelected = isSelected(row?.LabourCode);
              const isItemUsedBefore = isUsedBefore(row?.LabourCode);
              const disabled = isItemUsedBefore && !isItemSelected;
              return (
                <TableRow
                  onClick={(event) => handleClick(event, row?.LabourCode, disabled)}
                  role="checkbox"
                  aria-checked={isItemSelected}
                  tabIndex={-1}
                  key={`${row?.LabourCode}-${index}`}
                  selected={isItemSelected}
                >
                  <TableCell component="th" scope="row">
                    <Grid container spacing={0}>
                      <Grid item xs={12}>
                        <b>{highlight(row?.LabourCode)}</b>
                        {" "}
                        {highlight(row?.LabourDesc)}
                        <b>
                          <Chip size="small"
                            label={(parseInt(props.garantiTipi) === 1 ? row?.PriceWithoutWarranty : row?.Price) + " ₺"}
                          />
                        </b>
                      </Grid>
                    </Grid>
                  </TableCell>
                  <TableCell padding="checkbox">
                    <Checkbox
                      checked={isItemSelected || isItemUsedBefore}
                      inputProps={{ 'aria-labelledby': labelId }}
                      color="primary"
                      disabled={disabled}
                    />
                  </TableCell>
                </TableRow>
              )
            })}
          </TableBody>
        </Table>
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle id="alert-dialog-slide-title" color="primary">{"Bilgilendirme"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              {Uyari}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="primary">
              Tamam
          </Button>
          </DialogActions>
        </Dialog>
      </TableContainer>
    </>
  );
}


const mapStateToProps = (state) => ({
  labours: state.labourReducer,
  selectedDefects: state.defectReducer.selected,
});

const mapDispatchToProps = {
  setLabourSelection: setLabourSelection,
  setLabourQuan: setLabourQuan,
  setLabourFilterKey: setLabourFilterKey,
};

export default connect(mapStateToProps, mapDispatchToProps)(LabourTable)
